import { render, staticRenderFns } from "./ParcelDelivery.vue?vue&type=template&id=0ac1bd4b&"
import script from "./ParcelDelivery.vue?vue&type=script&lang=js&"
export * from "./ParcelDelivery.vue?vue&type=script&lang=js&"
import style0 from "./ParcelDelivery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports